// src/views/utils/formatTodayDate.js
export default {
  methods: {
    /**
     * 格式化当前日期为 yyyy-mm-dd 格式（核心方法，保留原有命名）
     * @returns {String} 格式化后的当前日期
     */
    formatTodayDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    /**
     * 格式化六个月前的日期为 yyyy-mm-dd 格式（贴合formatXXXDate命名风格）
     * @returns {String} 格式化后的六个月前日期
     */
    formatSixMonthsAgoDate() {
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
      const year = sixMonthsAgo.getFullYear();
      const month = String(sixMonthsAgo.getMonth() + 1).padStart(2, "0");
      const day = String(sixMonthsAgo.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    /**
     * 格式化日期范围（当前+六个月前）（贴合整体命名风格）
     * @returns {Object} { startTime: 六个月前日期, endTime: 当前日期 }
     */
    formatDateRange() {
      return {
        startTime: this.formatSixMonthsAgoDate(),
        endTime: this.formatTodayDate()
      };
    }
  }
};
